import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'antd';

// 创建一个唯一的存储键名
const createStorageKey = (surveyId = 'default') => `survey_shown_${surveyId}`;

export default function Index({ surveyId = '2026_satisfaction', surveyUrl = 'https://v.wjx.cn/vm/YYEvvHj.aspx#', surveyStartTime = '2026-07-08 00:00:00', surveyEndTime = '2026-07-21 18:00:00', delay = 300, }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    // 使用防抖，避免多次检查
    const timer = setTimeout(() => {
      const storageKey = createStorageKey(surveyId);
      // 检查是否在时间范围内
      const now = new Date();
      const startTime = new Date(surveyStartTime.replace(' ', 'T'));
      const endTime = new Date(surveyEndTime.replace(' ', 'T'));
      // 如果时间格式无效，默认不显示
      if (isNaN(startTime.getTime()) || isNaN(endTime.getTime())) {
        console.error('Invalid survey time format');
        return;
      }

      const isWithinTimeRange = now >= startTime && now <= endTime;

      if (!isWithinTimeRange) {
        return;
      }

      // 检查是否已经显示过
      const hasShown = localStorage.getItem(storageKey);
      if (hasShown === 'true') {
        return;
      }

      // 标记为已渲染，避免重复检查
      setShouldRender(true);
      setIsModalOpen(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [surveyId, surveyStartTime, surveyEndTime, delay]);

  const handleOk = () => {
    const storageKey = createStorageKey(surveyId);
    localStorage.setItem(storageKey, 'true');
    setIsModalOpen(false);

    const newWindow = window.open(surveyUrl, '_blank');
    if (!newWindow) {
      alert(`问卷链接无法自动打开，请手动访问：${surveyUrl}`);
    }
  };

  const handleCancel = () => {
    const storageKey = createStorageKey(surveyId);
    localStorage.setItem(storageKey, 'true');
    setIsModalOpen(false);
  };

  if (!shouldRender) return null;

  return (<Modal title="通知" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={[<Button key="primary" type="primary" onClick={handleOk}>      去评价    </Button>]} maskClosable={false}>    <div style={{ lineHeight: 1.6 }}>      各位领导同事大家好，2026年满意度调查开始了。请各位帮忙抽出1分钟，完成满意度调查问卷。感谢!!    </div>  </Modal>);
}